@if (!is_mobile) {
  <div class="categories">
    @for (category of categories; track category) {
      @for (option of category.items; track option; let i = $index) {
        <div
          [ngClass]="{ 'mb-1': i !== category.items.length - 1 }"
          (click)="
            handleCategorySelection(
              category.config.filter_config_id,
              option.item,
              option.other_group_items
            )
          "
        >
          <span
            class="d-flex asset-category-item"
            [ngClass]="{ 'asset-category-item-active': option.active }"
          >
            <a
              class="link-underline link-underline-opacity-0 px-2 focus-visible"
              href="javascript:void(0)"
            >
              <span class="material-icons material-symbols-outlined category-icon" [ngClass]="">
                {{ option.material_icon_class }}
              </span>
              {{ option.display_name }}
            </a>
          </span>
        </div>
      }
    }
  </div>
} @else {
  @if (categories) {
    <span>
      @for (item of categories[0].items; track item) {
        <button
          ngbDropdownItem
          class="mobile-list-sort__item"
          (click)="
            handleCategorySelection(
              categories[0].config.filter_config_id,
              item.item,
              item.other_group_items
            )
          "
        >
          {{ item.display_name }}
        </button>
      }
    </span>
  }
}
